<template>
  <div>
    <h3 class="mb-5">財務報告書</h3>

    <!-- itemList -->
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q1</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-母公司 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-母公司</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_parent1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-合併 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-合併</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_combo1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q2</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-母公司 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-母公司</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_parent2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-合併 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-合併</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_combo2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q1</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-母公司 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-母公司</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_parent3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-合併 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-合併</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_combo3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q4</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-母公司 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-母公司</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_parent4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-合併 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-合併</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.financial_combo4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    financial: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PageCollapse,
    FileUploader,
  },
};
</script>

<style></style>
